import { SignInfo } from '@/data/crypto-sign-info-types/types'

const initialSignInfo: SignInfo = {
  Name: '',
  UserInfo: {
    Fio: '',
    OrganizationName: ''
  },
  Certificate: {
    Issuer: '',
    Publisher: '',
    SerialNumber: '',
    ValidationDateRange: ''
  },
  SignObject: {
    File: {
      Name: '',
      Url: ''
    },
    LastChangeDate: ''
  },
  SignDocs: {
    Files: [
      {
        Name: '',
        Url: ''
      }
    ],
    LastChangeDate: ''
  },
  Signature: {
    IsValid: false,
    Content: ''
    // Sign: ''
  },
  Error: null
}

export default initialSignInfo